import { nnbsp } from 'console/utils/chars';
import { prettyFloat } from 'webui/utils/number';
export class GraphAxis {
    constructor() { }
    key() {
        return '???';
    }
    options() {
        return {};
    }
    create_axis_dict() {
        const opts = this.options();
        if (opts.show == null)
            opts.show = true;
        if (opts.tickFormatter == null)
            opts.tickFormatter = this.format_value;
        //        opts.labelWidth ?= 40
        return opts;
    }
    unit() {
        return '';
    }
    unit_separator() {
        return nnbsp;
    }
    format_value(value) {
        return prettyFloat(value, 2).replace('-', '–');
    }
    format_value_with_unit(value) {
        const unit = this.unit();
        if (unit == null) {
            return this.format_value(value);
        }
        return `${this.format_value(value)}${this.unit_separator()}${unit}`;
    }
}
